import React from "react";
import { createPortal } from "react-dom";

const WhatsAppFloat = () => {
  return createPortal(
  <a
      href="https://wa.me/917675929396?text=Hi%20I%20want%20to%20know%20more%20about%20Little%20Sanctum%20Preschool!"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        width: "60px",
        height: "60px",
        backgroundColor: "#25D366",
        color: "white",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "28px",
        textDecoration: "none",
        zIndex: 999999,
        boxShadow: "0 4px 10px rgba(0,0,0,0.3)"
      }}
    >
<svg
        width="28"
        height="28"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="white"
          d="M19.11 17.44c-.27-.13-1.6-.79-1.85-.88-.25-.09-.43-.13-.61.13-.18.27-.7.88-.86 1.06-.16.18-.31.2-.58.07-.27-.13-1.12-.41-2.13-1.3-.79-.7-1.33-1.56-1.48-1.83-.16-.27-.02-.41.12-.54.12-.12.27-.31.4-.47.13-.16.18-.27.27-.45.09-.18.04-.34-.02-.47-.07-.13-.61-1.47-.84-2.01-.22-.53-.45-.46-.61-.47h-.52c-.18 0-.47.07-.71.34-.25.27-.93.91-.93 2.22 0 1.31.95 2.58 1.08 2.76.13.18 1.87 2.86 4.52 4.01.63.27 1.12.43 1.5.55.63.2 1.2.17 1.65.1.5-.07 1.6-.65 1.82-1.27.22-.63.22-1.17.16-1.27-.07-.11-.25-.18-.52-.31Z"
        />
        <path
          fill="white"
          d="M26.6 5.4A13.37 13.37 0 0 0 16.98 1.5C9.45 1.5 3.33 7.62 3.33 15.15c0 2.4.63 4.74 1.82 6.81L3.2 30.5l8.72-1.9a13.57 13.57 0 0 0 5.06.97c7.53 0 13.65-6.12 13.65-13.65 0-3.65-1.42-7.08-4.03-9.52Zm-9.62 21.9c-1.6 0-3.17-.31-4.65-.93l-.33-.14-5.18 1.13 1.1-5.05-.16-.34a11.2 11.2 0 0 1-1.58-5.77c0-6.2 5.05-11.25 11.25-11.25 3 0 5.82 1.17 7.94 3.27a11.16 11.16 0 0 1 3.3 7.98c0 6.2-5.05 11.25-11.25 11.25Z"
        />
      </svg>
    </a>,
    document.body
     /*<div
    style={{
      position: "fixed",
      bottom: "20px",
      right: "20px",
      zIndex: 999999,
      background: "red",
      padding: "20px"
    }}
  >
    FLOAT TEST
  </div>,
  document.body*/
  );
};

export default WhatsAppFloat;
